import { ErrorBoundary } from 'react-error-boundary';
import { FingerprintProvider } from '@fingerprint/react';

import { User } from '@cast/types';

import { shouldEnableFingerprint, useUser } from './auth.state';
import { useSetFingerprint } from './hooks/useSetFingerprint';

type FingerprintInitInnerProps = {
  user: User;
};

const FingerprintInitInner = ({ user }: FingerprintInitInnerProps) => {
  useSetFingerprint(user);

  return null;
};

export const InitFingerprint = () => {
  const user = useUser();

  if (shouldEnableFingerprint(user)) {
    return (
      <ErrorBoundary fallbackRender={() => null}>
        <FingerprintProvider
          apiKey={window.env.VITE_FINGERPRINT_PUBLIC_KEY}
          endpoints={window.env.VITE_FINGERPRINT_PROXY_URL}
        >
          <FingerprintInitInner user={user} />
        </FingerprintProvider>
      </ErrorBoundary>
    );
  }

  return null;
};
